import http from '@/requests/http'
import appConfig from '@/config/app'
import utilityHelper from '@/helpers/utils'

class AutoCallSystemPublic {
  static all (params) {
    return http.post('auto-call-system/public/index', params)
  }
  static destroy (params) {
    return http.post('auto-call-system/public/destroy', params)
  }
  static checkAgentQueueStatus (params) {
    return http.post('auto-call-system/public/check-agent-queue-status', params)
  }
  static sendDataToPBX (params) {
    return http.post('auto-call-system/public/send-request-to-pbx', params)
  }
  static getCurrentStatus (params) {
    return http.post('auto-call-system/public/get-current-status', params)
  }
  static deleteAutoCallSystemPublicData (params) {
    return http.post('auto-call-system/public/delete', params)
  }
  static reUploadData (params) {
    return http.post('auto-call-system/public/re-upload', params)
  }
  static async store (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('auto-call-system/public/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static async downloadSampleImportFile (language) {
    window.open(`${appConfig.apiBaseUrl}/auto-call-system/public/import/sample/${language}`, '_blank')
  }
  static async exportAutoCallSystemData (companyId, userId, language, params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl}/auto-call-system/public/export/${companyId}/${userId}/${language}?${URLparams}`, '_blank')
  }
}

export default AutoCallSystemPublic
